import { BaseService } from '@common/http-layer/service/base.service'

export interface PageHitInput {
  eventType: string
  locationId: string
  path: string
  flavor: string // app flavor: clientportal | gokollab | courses
  appType: string // sidebar section (courses | communities | affiliates | …), else the app flavor
  contactId?: string
}

class ClientPortalAnalyticsService extends BaseService {
  constructor() {
    // Hit the clientportal-analytics service directly (not the /clientclub middleware). locationId
    // travels in the body, so the path is static.
    super({ baseURL: 'CLIENTPORTAL_ANALYTICS_SERVER_URL' })
  }

  // Fire-and-forget — non-blocking + keepalive so navigation/unload never breaks; errors swallowed.
  trackPageHit({ eventType, locationId, path, flavor, appType, contactId }: PageHitInput): void {
    const properties: Record<string, string> = {
      path,
      platform: 'web',
      flavor,
      appType,
    }
    if (contactId) properties.contactId = contactId

    const endpoint = '/track/events'

    void (async () => {
      try {
        await this.post(endpoint, { eventType, locationId, properties }, { keepalive: true })
      } catch (error) {
        this.logger.error('[ClientPortalAnalytics] page-hit failed', { error: error as Error, eventType, locationId })
      }
    })()
  }
}

export const clientPortalAnalyticsService = new ClientPortalAnalyticsService()
